/*
 File: email-feedback.js
 Author: ==> imported from BOM
 Modified: 3/12/2017
 Description: handle submit and ajax from email and feedback forms
 */

function initEmailFeedback() {
	
    $().ready(function() {
		function loadSendMsg() {
			if (typeof sendMsgInit == 'undefined') {
				var sendMsgJs = document.createElement('script');
				sendMsgJs.onload = function() {		
					sendMsgInit();
				};
				document.body.appendChild(sendMsgJs);
				sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
			} else {
				sendMsgInit();
			}
		}

		function loadSendFeedback() {
			if (typeof sendFeedbackInit == 'undefined') {
				var sendMsgJs = document.createElement('script');
				sendMsgJs.onload = function() {		
					sendFeedbackInit(null, {'header': 'Help us make Medscape the best clinical resource possible. Please use this form to submit your questions or comments on how to make this slideshow more useful to clinicians.', 'footer': 'Please <b><u>do not</u></b> use this form to submit personal or patient medical information or to report adverse drug events. You are encouraged to report adverse drug event information to the FDA.'});
				};
				document.body.appendChild(sendMsgJs);
				sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
			} else {
				sendFeedbackInit(null, {'header': 'Help us make reference on Medscape the best clinical resource possible. Please use this form to submit your questions or comments on how to make this article more useful to clinicians.', 'footer': 'Please <b><u>do not</u></b> use this form to submit personal or patient medical information or to report adverse drug events. You are encouraged to report adverse drug event information to the FDA.'});
			}
		}
		document.querySelectorAll('.social--email').forEach(function(elem) {
			elem.addEventListener('click', loadSendMsg);
		});

		document.querySelectorAll('.crs-utils__feedback').forEach(function(elem) {
			elem.addEventListener('click', loadSendFeedback);
		});
    });
	
}
export { initEmailFeedback };